<template>
    <div class="skill_link_list">
        <router-link to="/eval/eval_position_state" tag="a" id="target_to_position_button">
            <button :class="link_state === ''?'to_other_eval':'not_show'">返回评估</button>
        </router-link>
        <router-link to="/skill/self_score_state" tag="a" id="target_to_skill_button">
            <button :class="link_state !== ''?'to_other_eval':'not_show'">返回评估</button>
        </router-link>
        <router-link to="/position_target" tag="a" id="pos_target_button">
            <button :class="link_state === ''?'not_show':'to_target'">职业发展目标</button>
        </router-link>
        <router-link to="/skill/skill_target/hr" tag="a" id="position_to_hr_button">
            <button :class="link_state === ''?'to_target':'not_show'">专业技能目标</button>
        </router-link>
        <router-link to="/skill/skill_target/hr" tag="a" id="re_hr_button">
            <button :class="link_state === 'common'?'to_target':'not_show'">专业技能目标</button>
        </router-link>
        <router-link to="/skill/skill_target/common" tag="a" id="hr_to_common_button">
            <button :class="link_state === 'hr'?'to_target':'not_show'">通用技能目标</button>
        </router-link>
        <router-link to="/skill/skill_target/common" tag="a" id="pos_to_common_button">
            <button :class="link_state === ''?'to_target':'not_show'">通用技能目标</button>
        </router-link>
        <router-link to="/skill/skill_target" tag="a" id="self_score_hr_button">
            <button :class="link_state === 'hr'?'re_score':'not_show'">重新规划</button>
        </router-link>
        <router-link to="/skill/skill_target" tag="a" id="self_score_common_button">
            <button :class="link_state === 'common'?'re_score':'not_show'">重新规划</button>
        </router-link>
        <router-link to="/position_target" tag="a" id="re_eval_button">
            <button :class="link_state === ''?'re_score':'not_show'">重新规划</button>
        </router-link>
        <router-link to="/apps/plan" tag="a" id="common_to_plan_button">
            <button class="to_plan">行动计划</button>
        </router-link>
        <!--<router-link to="/goal" tag="a" id="eval_result_button">-->
            <!--<button :class="!data['is_eval'] && link_state === 'common'?'re_score':'not_show'">目标规划</button>-->
        <!--</router-link>-->
    </div>
</template>
<script type="text/javascript">

import { mapState, mapActions  } from 'vuex'

export default {
    data: function () {
        return {
            link_state: '',
        }
    },
    methods: {
        ...mapActions({

        }),

    },
    computed: {
        ...mapState({

        })
    },
    mounted: function () {
        this.link_state = localStorage.getItem('field')
    }
}

</script>
<style type="text/css">
.skill_link_list {
    background: #fff;
    display: -o-flex;
}
.skill_state_part {
    width: 33%;
    padding: 10px 15px;
    font-size: 16px;
    color: #565656;
    max-height: 45px;
    overflow: hidden;
    word-break: break-word;
    text-overflow: ellipsis;
}
.re_score{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #6699CC;
    border: 1px solid #6699CC;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.to_target{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #333366;
    border: 1px solid #333366;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.to_other_eval{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #99CC33;
    border: 1px solid #99CC33;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.to_plan{
    padding: .375rem .5rem;
    color: #fff;
    margin: 10px;
    background: #999999;
    border: 1px solid #999999;
    width: 200px;
    font-size: 1rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.not_show{
    display: none;
}

</style>
